module.exports = "/images/Interior---Hero.jpg";